import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { PayoutService } from 'src/app/services/payout.service';
import { FormControl, Validators } from '@angular/forms';
import * as uuid from 'uuid';
import { environment } from 'src/environments/environment';
const _clone = (d) => JSON.parse(JSON.stringify(d));
const swal = require('sweetalert');
@Component({
  selector: 'app-view-beneficiarie',
  templateUrl: './view-beneficiarie.component.html',
  styleUrls: ['./view-beneficiarie.component.scss']
})
export class ViewBeneficiarieComponent implements OnInit {
  tranferAmount:boolean=false;
  verifybeneficiary:boolean=true;
  newpayout:boolean=true;
  Processorvalue:any;
  accountno:any;
  ifscdata:any;
  payouttransaction=0;
  singleprocessor:boolean=true;
  transactionbtn:boolean=false;
  myItems=[];
  kycdata=[];
  AadharCardContentType:any;
  AadharCardContent:any;
  imgcontentType;
imgcontent;
display = 'none';
Content:any;
  private newAttribute: any = {};
  PayoutAccountKeyId:any;
  PayOutProcessorType= new FormControl("", [ Validators.required]);
  processorselection:boolean=false;
  PayOutprocessorList=[];
  processorList=[];
  PayOutProcessor= new FormControl("", [ Validators.required]);
  public Processorlist: Array<string> = [];
  ProcessorType:any;
  ProcessorId:any;
  Pid=0;
  responsetext:any;
  Paymentreasonmandate:boolean=false;
  nonmandatepaymentreason:boolean=true;
  mandatepaymentreason:boolean=false;
  MerchantKeyId:any;
  RTGSAmountErromessage:boolean=false;
  IMPSAmountErromessage:boolean=false;
  RTGSerrormessage:boolean=false;
  FullAccNo:boolean=false;
  CrossAccNo:boolean=true;
  FullAccountNumber;
  Contactrows;
  CustomerName:any;
  Id:any;
  TotalFeeAmount:any;
  TotalAmount:any;
  notVerifybeneficiary:boolean=false;
  Verifybeneficiary:boolean=true;
  Type:any;
  benficiaryerrormessage:boolean=false;
  showBenificiaryName:boolean=false;
  errormessage:boolean=false;
  benficiaryName:any;
  Beneficiariehide:boolean=false;
  balanceerromessage:boolean=false
  feesetuperromessage : boolean = false;
  Beneficiary:boolean=false;
  PayOutBeneficiary:boolean=false;
  showkyctab:boolean=false;
  Bid:any;
  PaymentReason= new FormControl("", [ Validators.required]);
  beneficiarykeyid= new FormControl("", [ Validators.required]);
  TransactionId:any;
  ContactId:any
  balance:any;
  dateerrormessage:boolean=false;
  dateoption:boolean=false;
  Date= new FormControl("", [ Validators.required]);
  public PType: Array<string> = ['NEFT', 'IMPS','RTGS'];
  public TType: Array<string> = ['Debit'];
  PayOutType = new FormControl("", [ Validators.required]);
  public PayType: Array<string> = ['Immediate', 'scheduled'];
  TransactionType= new FormControl("", [ Validators.required]);
  PaymentType= new FormControl("", [ Validators.required]);
  Amount= new FormControl("", [ Validators.required,
    Validators.max(10000000),
    Validators.min(10),
    Validators.pattern("^(?![a-zA-Z ])+[0-9]+((?![a-zA-Z@#$%^&*,()! ]).[0-9]{1,2})?$")]);
  PayoutCustomerkeyId= new FormControl("", [ Validators.required]);
  PayOutBeneficiaryKeyId= new FormControl("", [ Validators.required]);
  UpiId = new FormControl("",[Validators.required]);
  UpiIdShow:boolean=false;
  Viewbeneficiaries:boolean=true;
  transactiondetails:boolean=false;
  viewid:any;
  pcid:any;
  pbid:any;
  rows;
  BeneficiarieList = [];
  constructor(private route: ActivatedRoute,private service: PayoutService, private commonfunction: CommonFunctionService,private router:Router) { 
   this.Processordetails();
   this.getUserPermissions();
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.route.params.subscribe(params => {
      this.viewid = params['Id'];
      this.ContactId=params['PayoutCustomerkeyId'];
      this.Type=params['Type'];
     
      if(this.ContactId !=null)
      {
        let form = {
          PayoutCustomerkeyId: "",
          CustomerId: "",
          CompanyName: "",
          FirstName: "",
          LastName: "",
          Address: "",
          City: "",
          State: "",
          ZipCode: "",
          Country: "",
          MobileNo: "",
          MobileNo2: "",
          Email: "",
          Email2: "",
          UserDefined1: "",
          MerchantKeyId:0,
          UpdatedUserName:"",
          UserDefined2: "",
          UserDefined3: "",
          UserDefined4: "",
          UserDefined5: "",
          UserDefined6: "",
          UserDefined7: "",
          UserDefined8: "",
          UserDefined9: "",
          UserDefined10: "",
    
        };
        let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
        form.UpdatedUserName = this.commonfunction.getUserId();
        form.MerchantKeyId = merchantdata.MerchantKeyId;
        form.PayoutCustomerkeyId=this.ContactId
        this.service.ViewPayOutNameDetails(form).subscribe(res => {
         this.CustomerName=res;
 
        });
       
          this.service.ViewPayOutBeneficiarieList(this.ContactId, merchantdata.MerchantKeyId).subscribe(result => {
           this.errormessage=false;
            if(result.length <= 0)
            {
                   this.benficiaryerrormessage=true;
                   this.transactiondetails=false;
                   this.Viewbeneficiaries=false;
            }
            else{
              this.BeneficiarieList = result;


              this.Beneficiariehide=false;
              this.Beneficiary=true;
              this.PayOutBeneficiary=false;
       
                 this.Viewbeneficiaries=false;
                 this.transactiondetails=true;
            }
            
    
          });

      }
      else if(this.Type=="verification")
      {
         this.Viewbeneficiaries=true;
           this.transactiondetails=false
           this.notVerifybeneficiary=true;
           this.Verifybeneficiary=false;

           this.service.ViewBeneficiarieDetails(this.viewid, merchantdata.MerchantKeyId).subscribe(result => {
            this.rows=result;
            this.pbid=result.PayOutBeneficiaryKeyId;
            this.pcid=result.PayoutCustomerkeyId;
      
      
            if(this.rows.AccountNumber !=null)
            {
              this.FullAccountNumber=this.rows.AccountNumber
             var first6digits = this.rows.AccountNumber.slice(0, 6);
             var last4digits = this.rows.AccountNumber.slice(-4);
             this.rows.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
            }
      
      
            this.service.ViewPayOutBeneficiarieList(this.pcid, merchantdata.MerchantKeyId).subscribe(result => {
              this.BeneficiarieList = result;
        
            });
      
      
      
            if(this.ContactId ==null)
            {
              this.PayOutBeneficiary=true;
              this.Beneficiary=false;
              this.ContactId=this.pcid;
              this.BeneficiarieList = this.pbid;
            }
            if(this.rows.BankCodeType==0)
          {
            this.rows.BankCodeType="RoutingTransitNumber"
          }
          else if(this.rows.BankCodeType==1)
          {
            this.rows.BankCodeType="BankSortCodes"
          }
          else if(this.rows.BankCodeType==2)
          {
            this.rows.BankCodeType="BsbNumbers"
          }
          else if(this.rows.BankCodeType==3)
          {
            this.rows.BankCodeType="SwiftCode"
          }
          else if(this.rows.BankCodeType==4)
          {
            this.rows.BankCodeType="MicrCode"
          }
          else if(this.rows.BankCodeType==5)
          {
            this.rows.BankCodeType="IfscCode"
          }
          if(this.rows.BankAccountType==0)
          {
            this.rows.BankAccountType="SalaryAccount"
          }
          else if(this.rows.BankAccountType==1)
          {
            this.rows.BankAccountType="CurrentAccount"
          }
          else if(this.rows.BankAccountType==2)
          {
            this.rows.BankAccountType="SavingAccount"
          }
          else if(this.rows.BankAccountType==3)
          {
            this.rows.BankAccountType="RecurringDeposits"
          }
          else if(this.rows.BankAccountType==4)
          {
            this.rows.BankAccountType="FixedDeposits"
          }
        if(this.rows.BankAccountType==0)
                {
                  this.rows.BankAccountType="SalaryAccount"
                }
                else if(this.rows.BankAccountType==1)
                {
                  this.rows.BankAccountType="CurrentAccount"
                }
                else if(this.rows.BankAccountType==2)
                {
                  this.rows.BankAccountType="SavingAccount"
                }
                else if(this.rows.BankAccountType==3)
                {
                  this.rows.BankAccountType="RecurringDeposits"
                }
                else if(this.rows.BankAccountType==4)
                {
                  this.rows.BankAccountType="FixedDeposits"
                }
          });
           
      }
      else{
            // let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.ViewBeneficiarieDetails(this.viewid, merchantdata.MerchantKeyId).subscribe(result => {
      this.rows=result;
      this.pbid=result.PayOutBeneficiaryKeyId;
      this.pcid=result.PayoutCustomerkeyId;


      if(this.rows.AccountNumber !=null)
      {
        this.FullAccountNumber=this.rows.AccountNumber
       var first6digits = this.rows.AccountNumber.slice(0, 6);
       var last4digits = this.rows.AccountNumber.slice(-4);
       this.rows.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
      }

this.accountno=result.AccountNumber;
this.ifscdata=result.BankCode;
      this.service.ViewPayOutBeneficiarieList(this.pcid, merchantdata.MerchantKeyId).subscribe(result => {
        this.BeneficiarieList = result;
  
      });



      if(this.ContactId ==null)
      {
        this.PayOutBeneficiary=true;
        this.Beneficiary=false;
        this.ContactId=this.pcid;
        this.BeneficiarieList = this.pbid;
        
      }
      if(this.rows.BankCodeType==0)
    {
      this.rows.BankCodeType="RoutingTransitNumber"
    }
    else if(this.rows.BankCodeType==1)
    {
      this.rows.BankCodeType="BankSortCodes"
    }
    else if(this.rows.BankCodeType==2)
    {
      this.rows.BankCodeType="BsbNumbers"
    }
    else if(this.rows.BankCodeType==3)
    {
      this.rows.BankCodeType="SwiftCode"
    }
    else if(this.rows.BankCodeType==4)
    {
      this.rows.BankCodeType="MicrCode"
    }
    else if(this.rows.BankCodeType==5)
    {
      this.rows.BankCodeType="IfscCode"
    }
    if(this.rows.BankAccountType==0)
    {
      this.rows.BankAccountType="SalaryAccount"
    }
    else if(this.rows.BankAccountType==1)
    {
      this.rows.BankAccountType="CurrentAccount"
    }
    else if(this.rows.BankAccountType==2)
    {
      this.rows.BankAccountType="SavingAccount"
    }
    else if(this.rows.BankAccountType==3)
    {
      this.rows.BankAccountType="RecurringDeposits"
    }
    else if(this.rows.BankAccountType==4)
    {
      this.rows.BankAccountType="FixedDeposits"
    }
  if(this.rows.BankAccountType==0)
          {
            this.rows.BankAccountType="SalaryAccount"
          }
          else if(this.rows.BankAccountType==1)
          {
            this.rows.BankAccountType="CurrentAccount"
          }
          else if(this.rows.BankAccountType==2)
          {
            this.rows.BankAccountType="SavingAccount"
          }
          else if(this.rows.BankAccountType==3)
          {
            this.rows.BankAccountType="RecurringDeposits"
          }
          else if(this.rows.BankAccountType==4)
          {
            this.rows.BankAccountType="FixedDeposits"
          }
    });
      }

    });
  

   
  }

  ngOnInit() {
  }

  PaymentTypeChange(){

    var date = new Date();
    var hours = date.getHours();
    this.IMPSAmountErromessage=false;
   if(this.PaymentType.value =="UPI"){
     this.UpiIdShow = false;
   }
   else{
     this.UpiIdShow =false;
   }

   if(this.PaymentType.value =="RTGS")
   {
    var date = new Date();
    var first = date.getDate() - date.getDay();
    var last = first + 7; 
    var lastday = new Date(date.setDate(last)).toUTCString();
    lastday=lastday.slice(0, 3)
    var hours = date.getHours();
    var b=date.getMinutes();
     var Time=hours+":"+b;
     let today =date.getDay();
     var getday = new Date().toUTCString();
    var day=getday.slice(0, 3)
    if( day=="Sun")
    {
      this.RTGSerrormessage=true;
    }
    else
    {
      this.RTGSerrormessage=false; 
      var  RTGSAmount=+this.Amount.value;
      if(RTGSAmount !=0 && this.PaymentType.value=="RTGS")
      {
        if(RTGSAmount < 200000 && this.PaymentType.value =="RTGS" )
        {
          this.RTGSAmountErromessage=true;
        }
        else
        {
          this.RTGSAmountErromessage=false;


          var d = new Date();
          var getdate = d.getDate();
          var daynum = d.getDay();
          var weekOfMonth = Math.ceil((getdate + 6 - daynum)/7);
          var getday = new Date().toUTCString();
          var week=getday.slice(0, 3)
          if(week=="Sat")
          {
            if(weekOfMonth==2 || weekOfMonth==4)
            {
              this.RTGSerrormessage=true;
            }
            else
            {
              this.RTGSerrormessage=false;
            }
          }
          
        }
      }
   
    }
   }
   else{
    this.RTGSerrormessage=false ; 
    this.RTGSAmountErromessage=false;
   }

   var  IMPSAmount=+this.Amount.value;
   if(IMPSAmount !=0 && this.PaymentType.value=="IMPS")
   {
    if(IMPSAmount > 500000 && this.PaymentType.value =="IMPS" )
    {
      this.IMPSAmountErromessage=true;
    }
    else
    {
      this.IMPSAmountErromessage=false;
    }
   }


  }
  onButtonTypeChange()
  {
    var type=this.PayOutType.value;
    if(type=="scheduled")
    {
      this.dateoption=true;
    }
    else{
      this.dateoption=false;
    }
  }

  Addtransactiondetail()
  {
   this.Viewbeneficiaries=false;
    this.transactiondetails=true;
this.showkyctab=false;
    let form = {
      PayoutCustomerkeyId: "",
      CustomerId: "",
      CompanyName: "",
      FirstName: "",
      LastName: "",
      Address: "",
      City: "",
      State: "",
      ZipCode: "",
      Country: "",
      MobileNo: "",
      MobileNo2: "",
      Email: "",
      Email2: "",
      UserDefined1: "",
      MerchantKeyId:0,
      UpdatedUserName:"",
      UserDefined2: "",
      UserDefined3: "",
      UserDefined4: "",
      UserDefined5: "",
      UserDefined6: "",
      UserDefined7: "",
      UserDefined8: "",
      UserDefined9: "",
      UserDefined10: "",

    };
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.UpdatedUserName = this.commonfunction.getUserId();
    form.MerchantKeyId = merchantdata.MerchantKeyId;
    form.PayoutCustomerkeyId=this.ContactId
    this.service.ViewPayOutNameDetails(form).subscribe(res => {
     this.CustomerName=res;

    });
  }

  dateselection()
  {
    var date=this.Date.value;
    var currentdate=new Date().toISOString().slice(0, 10);
    date=new Date(date).toISOString().slice(0, 10);

  
    if(date >= currentdate)
    {
      this.dateerrormessage=false;
    }
    else{
      this.dateerrormessage=true;
    }
  
  }

  GetTransactionFee(){
    let form = {
      MerchantKeyId: 0,
      UniqueRequestId: "",
      PayOutType: "",
      PayOutDate: "",
      TransactionType: "",
      PaymentType: "",
      Amount: "",
      PayOutBeneficiaryKeyId: "",
      PayoutCustomerkeyId: "",
     
    }
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.MerchantKeyId = merchantdata.MerchantKeyId;
    const myId = uuid.v4();
    var uniqueid=myId.substring(0,9);
   form.MerchantKeyId= merchantdata.MerchantKeyId;
   form.UniqueRequestId= uniqueid;
   form.PayOutType= this.PayOutType.value;
   form.PayOutDate= this.Date.value;
   form.TransactionType= "Debit";
   form.Amount= this.Amount.value;
   form.PaymentType= this.PaymentType.value;
  //  form.PayOutBeneficiaryKeyId= this.pbid;
   

   this.service.getTransactionFee(merchantdata.MerchantKeyId,this.Amount.value).subscribe(result => {
    
    if (result != null) {
      
      if(result.TotalFeeAmount ==0){
        this.feesetuperromessage = true;
      }
      else{
      this.TotalFeeAmount = result.TotalFeeAmount;
      this.TotalAmount = Number(this.Amount.value)+ Number(result.TotalFeeAmount);
      this.feesetuperromessage = false;
    }
    }
  else{
    this.feesetuperromessage = true;
  }
  });
  
  }

  Transactiondetails()
  {
    let form = {
      MerchantKeyId: 0,
      UniqueRequestId: "",
      PayOutType: "",
      PayOutDate: "",
      TransactionType: "",
      PaymentType: "",
      Amount: "",
      PayOutBeneficiaryKeyId: "",
      PayoutCustomerkeyId: "",
      ProductData:"",
      PayoutAccountKeyId:"",
      AccountId:"",
      CreatedBy:"",
     
    }
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.MerchantKeyId = merchantdata.MerchantKeyId;
    const myId = uuid.v4();
    var uniqueid=myId.substring(0,9);
   form.MerchantKeyId= merchantdata.MerchantKeyId;
   form.UniqueRequestId= uniqueid;
   form.PayOutType= this.PayOutType.value;
   form.PayOutDate= this.Date.value;
   form.TransactionType= "Debit";
   form.Amount= this.Amount.value;
   form.PaymentType= this.PaymentType.value;
   form.PayoutAccountKeyId=this.PayoutAccountKeyId;
   form.AccountId=this.PayoutAccountKeyId;
   form.CreatedBy=merchantdata.UserId;
   if(this.PaymentReason.value !=null && this.PaymentReason.value !="")
    {
      form.ProductData=JSON.stringify(this.PaymentReason.value)
    }
  //  form.PayOutBeneficiaryKeyId= this.pbid;
  //  if(this.pbid !=null)
  //  {
  //   form.PayOutBeneficiaryKeyId= this.pbid;
  //  }
  //  else{
  //   form.PayOutBeneficiaryKeyId=this.beneficiarykeyid.value
  //  }
  form.PayOutBeneficiaryKeyId=this.beneficiarykeyid.value
   form.PayOutBeneficiaryKeyId = form.PayOutBeneficiaryKeyId.split('-')[0];
   if(this.pcid !=null)
   {
    form.PayoutCustomerkeyId= this.pcid;
   }
   else{
    form.PayoutCustomerkeyId= this.ContactId;
   }
 
   if(this.PayOutType.value=="scheduled")
   {
    var time= new Date().getHours() + ':' + new Date().getMinutes() + ':'+  new Date().getSeconds();
    form.PayOutDate=form.PayOutDate+" "+time;
   }
   this.service.newtransactiondetail(form).subscribe(result => {
    
    if (result != null) {
      if (result.Errorresponse !=null && result.Errorresponse.length>0) {
        if(result.Errorresponse[0].DeveloperMessage!=null)
        {
          this.responsetext=result.Errorresponse[0].DeveloperMessage;
          this.openConfirmationDialog();
        }
      }
     else if(result.ResponseCode == 2)
      {
        this.responsetext=result.ResponseText;
        this.openConfirmationDialog();
      }
      else
      {
        swal("Added", "Payout transaction initiated successfully", "success");
        this.router.navigate(["PayOut/PayOutTransactions"]);
      }
      
    }
  });

  
  }

showkycdetails(){
  this.showkyctab=true;
  this.GetKycdetails();
}
GetKycdetails(){
  let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  this.service.Getkycdetails(merchantdata.MerchantKeyId,this.FullAccountNumber,this.ifscdata).subscribe(result => {
    if (result != null) {
      this.kycdata = _clone(result);;
      this.AadharCardContent=result.AadharCardContent;
      this.AadharCardContentType=result.AadharCardContentType;
    }
  });
}
ModelClick(row) {
  if (row.AadharCardContentType == "application/pdf") {
    this.display = 'none';
    var byteCharacters = atob(row.AadharCardContent);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var file = new Blob([byteArray], { type: 'application/pdf;base64' });
    var fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  }
  this.imgcontent = row.AadharCardContent;
  this.imgcontentType = row.AadharCardContentType; 
}
  AmountCheck()
  {
this.checkPaymentReason();
  var amountdetails=this.Amount.value;
  this.IMPSAmountErromessage=false;
  var balance=this.balance;
  if(amountdetails <=balance)
  {
  this.balanceerromessage=false;
  }
  else{
    this.balanceerromessage=true;;
  }
  var  RTGSAmount=+this.Amount.value;
  if(RTGSAmount !=0 && this.PaymentType.value=="RTGS")
  {
    if(RTGSAmount < 200000 && this.PaymentType.value =="RTGS" )
    {
      this.RTGSAmountErromessage=true;
    }
    else
    {
      this.RTGSAmountErromessage=false;
      
      var d = new Date();
      var date = d.getDate();
      var day = d.getDay();
      var weekOfMonth = Math.ceil((date + 6 - day)/7);
      var getday = new Date().toUTCString();
      var week=getday.slice(0, 3)
      if(week=="Sat")
      {
        if(weekOfMonth==2 || weekOfMonth==4)
        {
          this.RTGSerrormessage=true;
        }
        else{
          this.RTGSerrormessage=false;
        }
      }
    
    }
  }


  if(RTGSAmount !=0 && this.PaymentType.value=="IMPS")
  {
    if(RTGSAmount > 500000 && this.PaymentType.value =="IMPS")
    {
      this.IMPSAmountErromessage=true;
    }
    else
    {
      this.IMPSAmountErromessage=false;
    }
  }
  this.GetTransactionFee()
  }

  PayOutTypeerrors()
  {
    return this.beneficiarykeyid.hasError("required")
    ? "PayOut Type is required"
      : "";
  }
  PayOutbeneficiarykeyid()
  {
    return this.PayOutType.hasError("required")
    ? "PayOut Beneficiary keyid is required"
      : "";
  }
  TransactionTypeerrors()
  {
    return this.TransactionType.hasError("required")
    ? "Transaction Type is required"
      : "";
  }
  PaymentTypeerrors()
  {
    return this.PaymentType.hasError("required")
    ? "Payment Type is required"
      : "";
  }
  Amounterrors()
  {
    return this.Amount.hasError("required")
    ? "Amount is required"
    : this.Amount.hasError("min") || this.Amount.hasError("max")
    ? "Enter valid amount (between 10-10000000)"
    : this.Amount.hasError("pattern")
      ? "Amount should be numaric(2 decimals)"
      : "";
  }
  Dateerrors()
  {
    return this.Date.hasError("required")
    ? "Date  is required"
      : "";
  }

  statuscheck()
  {
    let form = {
      MerchantKeyId: 0,
      UniqueRequestId: "",
      PayOutType: "",
      PayOutDate: "",
      TransactionType: "",
      PaymentType: "",
      Amount: 0,
      PayOutBeneficiaryKeyId: "",
      PayoutCustomerkeyId: "",
      LoginUserId:''
    }
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.MerchantKeyId = merchantdata.MerchantKeyId;
    const myId = uuid.v4();
    var uniqueid=myId.substring(0,9);
   form.MerchantKeyId= merchantdata.MerchantKeyId;
   form.UniqueRequestId= uniqueid;
   form.PayOutType= "Immediate";
   form.PayOutDate=  new Date().toString();
   form.TransactionType= "Debit";
   form.Amount= 1;
   form.PaymentType= "IMPS";
    form.PayOutBeneficiaryKeyId= this.pbid;
    form.PayoutCustomerkeyId= this.pcid;
    form.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
   this.service.VerifyBeneficiary(form).subscribe(result => {
    
    
    if (result != null) {

      if(result.ResponseCode==1)
      {
        swal("Verified", "Verified beneficiary", "success");
        this.router.navigate(["PayOut/BeneficiaryList"]);
      }
      else
      {
        swal("Pending", result.ResponseText, "warning");
        // this.router.navigate(["PayOut/BeneficiaryList"]);
      }
    }
  });
  
  }

  verify()
  {
    // window.location.href=environment.Verifybenficiary+this.Id;
    this.router.navigate(['/PayOut/ViewBeneficiaries',{Id: this.Id,Type:'verification'}]);
  }


  getbenficarydetails()
  {
   var bkeyid=this.beneficiarykeyid.value;
   bkeyid = bkeyid.split('-')[0];
   this.BeneficiarieList.forEach(element => {
  if (element.PayOutBeneficiaryKeyId == bkeyid) {
    if(element.Status !=2)
    {
      this.errormessage=true;
      this.Id=element.Id
    }
    else{
      this.errormessage=false;
      this.showBenificiaryName=true;
      this.benficiaryName=element.BeneficiaryName;
    }
  }
});
}


CreateBeneficiary()
{
    // this.router.navigate(['/PayOut/AddBeneficiaries'],{queryParams:{Id:this.ContactId}});
    this.router.navigate(['/PayOut/ManagePayOutContact']);
}
onSelect(x) {
  this.FullAccNo=true;
  this.CrossAccNo=false;
 }

 openConfirmationDialog() {
    
  swal({
    title: this.responsetext,
    text: '',
    icon: 'warning',
    buttons: {
      
        confirm: {
            text: 'Ok',
            value: true,
            visible: true,
            className: "",
            closeModal: true
        }
    }
}).then((isConfirm) => {
    if (isConfirm) {
      // this.Amount.reset('');
      window.location.reload();
    }
  
});

}


checkPaymentReason()
{
  let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  this.MerchantKeyId = merchantdata.MerchantKeyId;
  this.service.getPaymentReasondetail(this.MerchantKeyId,this.Amount.value).subscribe(result => {
    if(result==false)
    {
    this.nonmandatepaymentreason=false;
    this.mandatepaymentreason=true;
    this.Paymentreasonmandate=true;
    }
    else{
      this.nonmandatepaymentreason=true;
      this.mandatepaymentreason=false;
      this.Paymentreasonmandate=false;
    }
});
}
productdata()
{
  if(this.PaymentReason.value !=null && this.PaymentReason.value !="")
  {
    this.Paymentreasonmandate=false;
  }
  else
  {
    if(this.mandatepaymentreason==true)
    {
      this.Paymentreasonmandate=true;
    }
    else
    {
      this.Paymentreasonmandate=false;
    }
    }
}








Processordetails()
{
  this.processorselection=false;
  let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  this.service.GetPayoutprocessor(merchantdata.MerchantKeyId).subscribe(res => {



    if(res.length==1)
    {
      this.ProcessorId=res[0].PayoutProcessorId;
      this.PayoutAccountKeyId=res[0].PayoutAccountKeyId
      this.singleprocessor=true;
      this.processorselection=false;
      this.GetBalance()
    }
    else if(res.length>1)
    {
      // this.singleprocessor=false;
       this.processorselection=true;
     this.PayOutprocessorList= res;
     this.PayOutprocessorList.forEach(element => {
      if (element.IsDefault ==1)
      {
        var processorId=element.PayoutProcessorId;
        if(processorId==0)
        {
         this.Processorvalue="PayGDemo";
        }
        else if(processorId==1)
        {
          this.Processorvalue="IndusInd";
        }
        else if(processorId==2)
        {
          this.Processorvalue="YesBank";
        }
        else if(processorId==3)
        {
          this.Processorvalue="AxisBank";
        }
        else if(processorId==4)
        {
          this.Processorvalue="IDFC";
        }
        this.processordelection();
      }
     });
     this.PayOutprocessorList.forEach(element => {
      // && element.IsDefault==1
        if (element.PayoutProcessorId ==0 &&(element.PayoutAccountKeyId !="" && element.PayoutAccountKeyId !=null))
         {
          var PayoutProcessorId="PayGDemo"
          var PayoutAccountKeyId=element.PayoutAccountKeyId;
          this.newAttribute = {PayoutAccountKeyId,PayoutProcessorId}; 
          this.myItems.push(this.newAttribute); 
        }
        else if (element.PayoutProcessorId ==1 &&(element.PayoutAccountKeyId !="" && element.PayoutAccountKeyId !=null))
        {
         var PayoutProcessorId="IndusInd"
         var PayoutAccountKeyId=element.PayoutAccountKeyId;
         this.newAttribute = {PayoutAccountKeyId,PayoutProcessorId}; 
         this.myItems.push(this.newAttribute); 
        }
        else if (element.PayoutProcessorId ==2 &&(element.PayoutAccountKeyId !="" && element.PayoutAccountKeyId !=null))
        {
          var PayoutProcessorId="YesBank"
         var PayoutAccountKeyId=element.PayoutAccountKeyId;
         this.newAttribute = {PayoutAccountKeyId,PayoutProcessorId}; 
         this.myItems.push(this.newAttribute); 
        }
        else if (element.PayoutProcessorId ==3 &&(element.PayoutAccountKeyId !="" && element.PayoutAccountKeyId !=null))
        {
          var PayoutProcessorId="AxisBank"
         var PayoutAccountKeyId=element.PayoutAccountKeyId;
         this.newAttribute = {PayoutAccountKeyId,PayoutProcessorId}; 
         this.myItems.push(this.newAttribute); 
        }
        else if (element.PayoutProcessorId ==4 &&(element.PayoutAccountKeyId !="" && element.PayoutAccountKeyId !=null))
        {
          var PayoutProcessorId="IDFC"
         var PayoutAccountKeyId=element.PayoutAccountKeyId;
         this.newAttribute = {PayoutAccountKeyId,PayoutProcessorId}; 
         this.myItems.push(this.newAttribute); 
        }
      });

         if(this.myItems.length>1)
         {
           this.singleprocessor=false;
           this.processorselection=true;
         }
    }
  });

}


GetBalance()
{
  let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  this.service.GetAccountBalance(merchantdata.MerchantKeyId,this.ProcessorId).subscribe(result => {
    if(result !=null)
    {
      this.balance=result.CurrentBalance;
      if(this.Amount.value>'0')
      {
        this.AmountCheck()
      }
    }
  });
}
processordelection()
{
  this.myItems.forEach(element => {
    // && element.IsDefault==1
      if (element.PayoutProcessorId ==this.PayOutProcessorType.value)
       {
           this.PayoutAccountKeyId=element.PayoutAccountKeyId
           this.ProcessorId=element.PayoutProcessorId ;
           if(this.ProcessorId=="PayGDemo")
           {
            this.ProcessorId=0;
           }
            else if(this.ProcessorId=="IndusInd")
            {
              this.ProcessorId=1;
            }
            else if(this.ProcessorId=="YesBank")
            {
              this.ProcessorId=2;
            }
            else if(this.ProcessorId=="AxisBank")
            {
              this.ProcessorId=3;
            }
            else if(this.ProcessorId=="IDFC")
            {
              this.ProcessorId=4;
            }
           this.GetBalance()
      }
    
    });
   
}

payoutmakerandchecker(){
  {
    let form = {
      MerchantKeyId: 0,
      UniqueRequestId: "",
      PayOutType: "",
      PayOutDate: "",
      TransactionType: "",
      PaymentType: "",
      Amount: "",
      PayOutBeneficiaryKeyId: "",
      PayoutCustomerkeyId: "",
      ProductData:"",
      PayoutAccountKeyId:"",
      AccountId:"",
      CreatedBy:"",
     
    }
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.MerchantKeyId = merchantdata.MerchantKeyId;
    const myId = uuid.v4();
    var uniqueid=myId.substring(0,9);
   form.MerchantKeyId= merchantdata.MerchantKeyId;
   form.UniqueRequestId= uniqueid;
   form.PayOutType= this.PayOutType.value;
   form.PayOutDate= this.Date.value;
   form.TransactionType= "Debit";
   form.Amount= this.Amount.value;
   form.PaymentType= this.PaymentType.value;
   form.PayoutAccountKeyId=this.PayoutAccountKeyId;
   form.AccountId=this.PayoutAccountKeyId;
form.CreatedBy=merchantdata.UserId;
   if(this.PaymentReason.value !=null && this.PaymentReason.value !="")
    {
      form.ProductData=JSON.stringify(this.PaymentReason.value)
    }
  //  form.PayOutBeneficiaryKeyId= this.pbid;
  //  if(this.pbid !=null)
  //  {
  //   form.PayOutBeneficiaryKeyId= this.pbid;
  //  }
  //  else{
  //   form.PayOutBeneficiaryKeyId=this.beneficiarykeyid.value
  //  }
  form.PayOutBeneficiaryKeyId=this.beneficiarykeyid.value
   form.PayOutBeneficiaryKeyId = form.PayOutBeneficiaryKeyId.split('-')[0];
   if(this.pcid !=null)
   {
    form.PayoutCustomerkeyId= this.pcid;
   }
   else{
    form.PayoutCustomerkeyId= this.ContactId;
   }
 
   if(this.PayOutType.value=="scheduled")
   {
    var time= new Date().getHours() + ':' + new Date().getMinutes() + ':'+  new Date().getSeconds();
    form.PayOutDate=form.PayOutDate+" "+time;
   }
   this.service.fundtransfermaker(form).subscribe(result => {
    if (result != null) {
      if (result.Errorresponse !=null && result.Errorresponse.length>0) {
        if(result.Errorresponse[0].DeveloperMessage!=null)
        {
          this.responsetext=result.Errorresponse[0].DeveloperMessage;
          this.openConfirmationDialog();
        }
      }
     else if(result.ResponseCode == 2)
      {
        this.responsetext=result.ResponseText;
        this.openConfirmationDialog();
      }
      else
      {
        swal("Added", "Payout transaction initiated successfully", "success");
        this.router.navigate(["PayOut/PayOutTransactions"]);
      }
      
    }
  });

} 
}
getpermission(){
  const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  this.service.GetuserRoleBasedPermissions(merchantdata.UserId,merchantdata.UserType ).subscribe(result => {
    if (result != null) {
      for (var i in result) {
        if (result[i].UserPermission == 'PayOutApprove') {
          var type = result[i].Type;
          if (type == 'RWD') {
            this.payouttransaction=1;
          }      
        }
      }
      if( this.payouttransaction==1){
        this.transactionbtn=true;
        this.Transactiondetails();
      }
      else{
        this.transactionbtn=true;
        this.payoutmakerandchecker();
      }
    }
  });
}


getUserPermissions() {
  const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  this.service.GetuserRoleBasedPermissions(merchantdata.UserId, "Merchant").subscribe(result => {
    if (result != null) {
      for (var i in result) {
        if (result[i].UserPermission == 'PayOut') {
          var type = result[i].Type;
          if (type == 'R') 
          {
             
              this.newpayout=false;
              this.verifybeneficiary=false;
              this.tranferAmount=false;
              

          }
         else if (type == 'RW') 
          {
            this.newpayout=true;
            //this.verifybeneficiary=true;
            //this.tranferAmount=true;
            if(merchantdata.UserType !='Reseller' && merchantdata.UserType !='ResellerUser')
            {
              this.verifybeneficiary=true;
              this.tranferAmount=true;
            }
            else{
              this.verifybeneficiary=false;
              this.tranferAmount=false;
            }



          }
         else if (type == 'RWD') 
          {
            this.newpayout=true;
            //this.verifybeneficiary=true;
            //this.tranferAmount=true;
            if(merchantdata.UserType !='Reseller' && merchantdata.UserType !='ResellerUser')
            {
              this.verifybeneficiary=true;
              this.tranferAmount=true;
            }
            else{
              this.verifybeneficiary=false;
              this.tranferAmount=false;
            }



          }
        }
      }

    }

  });
}
}